import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { FileUtils, ApiUtils } from '@shared/utils';
import { PaymentApi } from '@shared/api/rest';
import { type IQueryParams, RequestStrategyEnum } from '@shared/api/models';

export const generateOutgoingPaymentEffect = createEffect((params: IQueryParams<string>) =>
  PaymentApi.generateOutgoingPayment(params.request, params?.signal),
);
const clearEvent = createEvent();

const $loadingStore = createStore<boolean>(false)
  .on(generateOutgoingPaymentEffect.pending, (_, data) => data)
  .on(generateOutgoingPaymentEffect.fail, () => false)
  .on(generateOutgoingPaymentEffect.done, () => false)
  .reset(clearEvent);

generateOutgoingPaymentEffect.done.watch((result) => FileUtils.downloadFile(result.result, `Deposit Payment Report - ${result.params.request}`));
generateOutgoingPaymentEffect.fail.watch((x) => $notificationStore.events.setError(x.error.message));

export const $generateOutgoingPaymentStore = {
  events: {
    generateOutgoingPayment: ApiUtils.wrapperApi(generateOutgoingPaymentEffect, RequestStrategyEnum.Debounce),
    clear: clearEvent,
  },
  store: combine({ loading: $loadingStore }),
};
